import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FamilyMembershipService {

  private apiUrl = `${environment.apiUrl}/familymembership`; // API URL'si

  constructor(private http: HttpClient) {}

   getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    const herader = {
      skipLoad: 'true',
    }
    return this.http.get<any>(`${this.apiUrl}/${countryId}`,{headers: herader});
  }



}
